/**
 * Format a timestamp as a bare lowercase clock time — `3:20 pm`, `12:05 am`.
 *
 * `toLocaleTimeString` yields `3:20 PM`; the chat surface wants a lowercase
 * meridiem with a padded minute. No date context is added — callers that need
 * day disambiguation pair this with a separate date label.
 */
export default function formatClockTime(date: Date): string {
  return date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true }).toLowerCase();
}
